import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Discussions.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import Service from '../service/Service';
import User from './common/User';
import DiscussionLinks from './common/DiscussionLinks';
import DiscussionContent from './common/DiscussionContent';
import CommentOverlay from './common/CommentOverlay';
import UserListOverlay from './common/UserListOverlay';
import ModerationOverlay from './common/ModerationOverlay';

const service = new Service();

class Discussions extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let serverSideData = {};
        this.totalCount = 0;
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData && serverSideData['result']) {
            initialData = serverSideData['result'];
            this.totalCount = parseInt(serverSideData['discussionCount']);
        }
        this.state = {
            initialData: initialData,
            metaTitle: "Discussions on Pregnancy, Parenting, Baby Care & more",
            metaDescription: [
                { "name": "description", "content": "Join the Firstcry Parenting discussions and be a part of one of the largest & active online communities. Discuss & stay updated on a host of useful & interesting topics." }
            ]
        };

        this.disPageNo = 1;
        if (this.props.match.params.page && this.props.match.params.page > 0) {
            this.disPageNo = parseInt(this.props.match.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let size = 10;
        // if (reqUrl.includes('/page/')) {
        //     size = parseInt(reqUrl.split('/').pop()) * 10;
        // }
        var url = global.api_url + "discussion/getdiscussionlist";
        let body = JSON.stringify({
            "pagesize": size,
            "pageno": 1
        })
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {

        document.addEventListener("click", actions.domClick);
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
        if (navigator.onLine) {
            let size = 10;
            if (this.disPageNo > 1) {
                size = 10 * this.disPageNo;
            }
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                this.discussionData(1, size);
            } else {
                localStorage.setItem('discussionLanding', JSON.stringify(this.state.initialData));
                localStorage.setItem('discussionLandingCnt', JSON.stringify(this.totalCount));
                actions.loadSliders();
                actions.loadReadMore();
            }
        } else {
            if (localStorage.getItem('discussionLanding')) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('discussionLanding')) }, () => { actions.loadSliders(); actions.loadReadMore(); });
            }
            if (localStorage.getItem('discussionLandingCnt')) {
                this.totalCount = localStorage.getItem('discussionLandingCnt');
            }
            service.hideLoader();
        }
        actions.setWidth();
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.pageData, false);
        document.removeEventListener("click", actions.domClick);
    }

    appendURL() {
        this.props.history.push(service.getRedirectUrl("/discussions/page/" + this.disPageNo));
    }

    pageData() {
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('data-container')[0]) {
                var cS = document.getElementsByClassName('data-container')[0].offsetTop;
                var cH = document.getElementsByClassName('data-container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                if (!((window.innerHeight + window.scrollY) >= document.body.offsetHeight) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount > (_this.disPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.disPageNo;
                        service.showLoader();
                        service.showTracking();
                        _this.discussionData(_this.disPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }

    discussionData(pageno, size) {
        var postData = {
            "pagesize": size,
            "pageno": pageno
        }
        var url = global.api_ci_url + "Discussions/getdiscussionlist";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                if (this.state.initialData.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ initialData: json['result'] }, () => { service.loadImages(); actions.loadSliders(); actions.loadReadMore(); });
                    } else {
                        let ary = this.state.initialData;
                        this.setState({ initialData: ary.concat(json['result']) }, () => { service.loadImages(); actions.loadSliders(); actions.loadReadMore(); });
                    }
                    // if (parseInt(pageno) != 1) {
                    //     this.appendURL();
                    // }
                } else {
                    localStorage.setItem('discussionLanding', JSON.stringify(json['result']));
                    localStorage.setItem('discussionLandingCnt', JSON.stringify(json['discussionCount']));
                    this.totalCount = parseInt(json['discussionCount']);
                    this.setState({ initialData: json['result'] }, () => { service.loadImages(); actions.loadSliders(); actions.loadReadMore(); });
                }
            }
            service.hideLoader();
            service.hideTracking();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
            service.hideTracking();
        });
    }

    reloadData() {
        var _this = this;
        setTimeout(() => {
            service.showLoader();
            _this.discussionData(_this.disPageNo, (_this.disPageNo * 10));
        }, 500)
    }

    render() {
        return (
            <main className="discussions-main main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Discussions</span>
                    </div>
                    <h1 className="B24_00">Discussions</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        {this.state.initialData && this.state.initialData.map((discussion, index) =>
                            <div key={index} className="discussion-block" id={`discussion_${discussion.discussionId}`}>
                                <Link to={service.getRedirectUrl(`/discussions/t/${service.replaceSymbols((actions.only_title(discussion.title)) + '-' + (discussion.discussionId))}`)}>
                                    <User user={discussion} isAnonymus={0} eleRef={this} />
                                </Link>
                                <DiscussionContent discussion={discussion} linkUrl={`/discussions/t/${service.replaceSymbols((actions.only_title(discussion.title)) + '-' + (discussion.discussionId))}`} isDisLanding={true} eleRef={this} />
                                <div className="divider_line"></div>
                                <DiscussionLinks discussion={discussion} eleRef={this} />
                            </div>
                        )}
                        {(!this.state.initialData || this.state.initialData.length < 1) &&
                            <div className="discussion-block"></div>
                        }
                    </div>
                </div>
                <input type="hidden" id="post_commentId" value="" />
                <input type="hidden" id="post_parentUserId" value="" />
                <input type="hidden" id="post_parentUserName" value="" />
                <input type="hidden" id="post_parentIsAnonymus" value="" />
                <input type="hidden" id="post_replyId" value="" />
                <input type="hidden" id="post_dId" value="" />
                <input type="hidden" id="post_gId" value="" />
                <input type="hidden" id="post_cId" value="" />
                <input type="hidden" id="post_dUrl" value="" />
                <CommentOverlay eleRef={this} />
                <UserListOverlay eleRef={this} />
                <div className="share-overlay"></div>
                <Right url={this.props.match.url} />
                <ModerationOverlay />
            </main>
        )
    }
}

export default Discussions;



// WEBPACK FOOTER //
// src/shared/discussions/Discussions.js